var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background-color":"#ffffff"}},[_c('Header'),_c('v-content',{staticClass:"v-content-container",attrs:{"id":"content-container"}},[_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('router-view')],1)],1),_c('Footer',{attrs:{"id":"footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }